const sliderNews = () => {
    const sliders = document.querySelectorAll('.block-news__slider');
    if (!sliders.length) return;

    sliders.forEach(slider => {
        const section = slider.closest('.block-news');
        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: section.querySelector('.swiper-pagination'),
                type: 'fraction',
            },
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                },
            },
        });
    });
};

export default sliderNews;
